export default "__VITE_ASSET__2189a3bb__"